import * as zod from 'zod';

import { CaptureConfig } from '../Capture/captureConfig';

/**
 * The Inspect step's configuration: the skill to run, and where to write the
 * frame it ran on.
 *
 * Camera, processor, workflow, class list and per-class thresholds are all read
 * from the saved skill at play time, so the step exposes none of those and a
 * skill retuned in the wizard changes what every routine using it counts.
 *
 * `captureConfig` is the exception, and it belongs to the routine rather than
 * to the skill: two routines running the same Inspect skill can reasonably file
 * their records in different places, and the filepath is an expression that
 * resolves against the routine's own variables.
 */
const Arguments = zod.object({
  skillId: zod.string(),
  captureConfig: CaptureConfig.optional(),
});

export default Arguments;
